import Tooltip from '@components/common/Tooltip';

const Chart1 = () => {
    return (
        <>
            <div className="custom-card card hrm-main-card info">
                <div className="card-body">
                    <div className="d-flex align-items-center mb-3">
                        <div className="me-3">
                            <div className="avatar avatar-md rounded-4 bg-info shadow shadow-info text-fixed-white">
                                <i className="ri-dashboard-3-line fs-18"></i>
                            </div>
                        </div>
                        <div className="flex-fill">
                            <p className="mb-1 text-muted">
                                VPD - 수증기압차
                                <Tooltip
                                    content="도움말이 표시될예정"
                                    customClass="tooltip-dark"
                                    placement="top"
                                >
                                    <i className="ri-question-line" />
                                </Tooltip>
                            </p>
                            <div className="d-flex align-items-top justify-content-between">
                                <h5 className="fw-semibold mb-0 lh-1">높음</h5>
                                <div className="text-info fw-semibold">
                                    1.15
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <small>
                            작물의 수분 증발량이 증가합니다. 작물이 마를 수
                            있으니 수분관리에 유의해주세요
                        </small>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Chart1;
